/* ==========================================================================
   IRON FIT — Package preview page controller  (bundle.html?b=famous)

   One template for all five packages. Everything it shows comes from
   ifz-bundles.js, so the carousel card and this page can never disagree.

   What it owns:
     · the poster, the pitch and the "bought one by one" value block
     · the photo tiles for every piece of kit in the box
     · the extras the card used to hide behind an accordion: pairs of
       5 / 10 / 20 kg plates at the $2.50/kg package rate (capped at 80 kg)
     · one live total, shared by the order block and the phone buy bar
   ========================================================================== */
(function () {
  'use strict';

  var PKG_PLATE_RATE = 2.5;   /* $/kg — the package rate */

  /* Flooring rides along with a package at the same $39 per m² the
     accessories page charges. Unlike plates it has no package rate to
     undercut, because no package contains any — so there is nothing here
     that could be charged twice. See IFZFloor in ifz-cart.js for why four
     tiles — one square metre — is the smallest order. */
  var FLOOR_PER_M2 = 39;

  var LIST = window.IFZ_BUNDLES || [];
  var money = window.IFZCart.money;

  function qs(id) { return document.getElementById(id); }

  /* Every photo on this page ships as WebP too — about half the bytes.
     Through IFZA, always: on Shopify these files live on the CDN with no
     assets/ folder to be relative to, and this page is /pages/package, so
     a bare 'assets/x.webp' resolves to /pages/assets/x.webp and 404s. */
  function url(f) { return window.IFZA ? window.IFZA(f) : f; }
  function webp(f) { return url(f).replace(/\.(jpe?g|png)$/i, '.webp'); }

  function picture(src, alt, cls) {
    return '<picture><source type="image/webp" srcset="' + webp(src) + '">' +
           '<img src="' + url(src) + '" alt="' + alt + '"' +
           (cls ? ' class="' + cls + '"' : '') + ' loading="lazy" decoding="async"></picture>';
  }

  function q(name) {
    var m = new RegExp('[?&]' + name + '=([^&]+)').exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ------------------------------------------------------------------
     TWO WAYS IN, AND THEY MEAN DIFFERENT THINGS

       ?b=famous-60   one exact package. The weight has been chosen.
       ?fam=famous    the family. The weight has NOT been chosen yet.

     Seven of the eight packages are really two machines in several plate
     weights. That used to be asked in a floating chooser before the page
     loaded; it is the first step ON this page now, which is why the page
     has to be able to open without an answer to it.

     Arriving with neither — a bare /pages/package — is the family too. A
     visitor who named no weight has not chosen one, and quietly handing
     them the lightest box is how somebody pays for 20 kg believing they
     compared it against 80.
     ------------------------------------------------------------------ */
  var T = window.IFZTiers;
  var askedFam = q('fam');
  var askedB = q('b');

  var FAM = (askedFam && T) ? T.groupByKey(askedFam) : null;
  var B = LIST.byId(askedB) || (FAM && FAM.tiers[0]) || LIST.byId('famous') || LIST[0];
  if (!B) return;
  if (!FAM && T) FAM = T.groupFor(B.id);

  /* B is a real package either way — the page needs a poster, a contents
     list and a machine to render at all. While the weight is unchosen it
     stands in as the family's base, and every number that differs between
     tiers is printed as "from" until the question is answered. */
  var tierChosen = !FAM || (!!askedB && !askedFam);

  function tierNeeded() { return !!FAM && !tierChosen; }

  function famLow() {
    return Math.min.apply(null, FAM.tiers.map(function (t) { return t.price; }));
  }
  function famSave() {
    var best = 0;
    FAM.tiers.forEach(function (t) {
      if (t.was && t.was > t.price) best = Math.max(best, t.was - t.price);
    });
    return best;
  }

  var state = { plates: 0, mix: null, floor: 0 };

  /* ======================================================================
     THE PITCH
     ====================================================================== */

  function head() {
    var pending = tierNeeded();

    document.title = 'Iron Fit — ' + (pending ? FAM.name : B.name);

    var poster = qs('poster');
    poster.src = url(B.img);
    poster.alt = B.name + ' — everything included, standing together';

    /* The poster is the biggest thing on the page, so a phone at 3× and a
       retina laptop both ask for more pixels than the master has. Offer the
       1400px variant alongside it and let the browser take the one its own
       screen needs — an ordinary screen still downloads the small one. */
    var SIZES = '(max-width: 980px) calc(100vw - 26px), 42vw';

    if (B.img2x) {
      poster.srcset = url(B.img) + ' 848w, ' + url(B.img2x) + ' 1400w';
      poster.sizes = SIZES;
      qs('posterWebp').srcset = webp(B.img) + ' 848w, ' + webp(B.img2x) + ' 1400w';
      qs('posterWebp').sizes = SIZES;
    } else {
      qs('posterWebp').srcset = webp(B.img);
    }

    /* Written both ways round every time rather than only when true: this
       runs again each time a weight is picked, and a one-way assignment —
       hide it, set the ghost class — cannot be undone by the next run. */
    var badge = qs('badge');
    badge.textContent = B.badge;
    badge.className = 'bposter__badge' + (B.solid ? '' : ' bposter__badge--ghost');

    qs('kick').textContent = pending ? 'Choose your plates'
                           : B.best ? 'The one everybody orders'
                           : 'Complete package';
    qs('bname').textContent = pending ? FAM.name : B.name;
    qs('btag').textContent = pending
      ? 'Same machine, same bench, same 7 ft bar — you choose the weight in the box.'
      : B.tagline;
    qs('blead').innerHTML = B.lead;

    qs('bprice').textContent = (pending ? 'from ' : '') + money(pending ? famLow() : B.price);

    /* The saving is the biggest one in the family while the weight is open,
       and this package's own once it is settled. */
    var save = pending ? famSave() : (B.was ? B.was - B.price : 0);
    var was = qs('bwas');
    var chip = qs('bsaveChip');
    was.textContent = B.was ? money(B.was) : '';
    was.hidden = pending || !B.was;
    chip.textContent = save ? (pending ? 'Save up to ' : 'Save ') + money(save) : '';
    chip.hidden = !save;

    /* The one-by-one comparison needs a settled price on both sides of it,
       so it waits for the weight rather than comparing against a "from". */
    qs('bvalue').hidden = pending || !B.was;
    if (!pending && B.was) {
      qs('vSep').textContent = money(B.was);
      qs('vPkg').textContent = money(B.price);
      qs('vSave').textContent = money(B.was - B.price);
    }

    if (window.IFZPixel) {
      window.IFZPixel.viewContent(pending ? FAM.name : B.name, pending ? famLow() : B.price);
    }

    qs('insideSub').textContent = B.items.length === 1
      ? 'One machine, delivered and installed by our own team.'
      : B.items.length + ' things arrive together, in one delivery, installed in one visit.';
  }

  /* ======================================================================
     SEE IT IN 3D  ·  SEE IT IN YOUR ROOM

     Straight under the price, above everything else, because these are the
     two questions a customer actually has in front of a $900 machine: what
     does it really look like, and will it go in my room. The 3D viewer is
     the same one the machine pages use.
     ====================================================================== */
  function threeD() {
    if (!B.machine || !window.IFZ3D) return;
    var spec = window.IFZ3D.spec(B.machine);
    if (!spec) return;

    var wrap = document.createElement('div');
    wrap.className = 'b3d';

    var anchor = qs('bvalue').hidden ? qs('blead') : qs('bvalue');
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);

    spec.name = B.items[0] ? B.items[0].name : B.name;
    window.IFZ3D.attach(spec, wrap);      /* adds its own "See it in 3D" button */
  }

  /* ======================================================================
     WHAT'S IN THE BOX
     ====================================================================== */

  function items() {
    var box = qs('bitems');
    if (B.items.length === 1) box.classList.add('bitems--single');
    B.items.forEach(function (it, i) {
      var tile = document.createElement('article');
      tile.className = 'bitem';
      tile.innerHTML =
        '<div class="bitem__pic">' +
          '<span class="bitem__no">' + (i + 1) + '</span>' +
          picture(it.img, it.name, it.fit === 'contain' ? 'is-fit' : '') +
        '</div>' +
        '<div class="bitem__tx">' +
          '<b></b><small></small>' +
          '<span class="bitem__in">Included</span>' +
        '</div>';
      tile.querySelector('b').textContent = it.name;
      tile.querySelector('small').textContent = it.spec;
      box.appendChild(tile);
    });

    var perks = qs('bperks');
    B.perks.forEach(function (t) {
      var li = document.createElement('li');
      li.textContent = t;
      perks.appendChild(li);
    });
  }


  /* ======================================================================
     HOW THE PLATES COME

     The same 20 kg can arrive as one pair of 10s or two pairs of 5s, and
     which one you want depends on how you train: four 5s let you add 10 kg
     at a time to a bar, a pair of 10s is fewer plates to store. It costs us
     nothing to ask, and getting it wrong means a customer who has to buy
     plates twice.

     Plates always come in pairs — a bar loaded unevenly is no use to
     anybody — so every option below is built from pairs.
     ====================================================================== */

  var PLATE_MIXES = {
    20: [
      { id: '10x2',      label: '2 × 10 kg',                 note: 'Fewest plates to store' },
      { id: '5x4',       label: '4 × 5 kg',                  note: 'Add 10 kg at a time' }
    ],
    40: [
      { id: '20x2',      label: '2 × 20 kg',                 note: 'Fewest plates to store' },
      { id: '10x4',      label: '4 × 10 kg',                 note: 'A good all-round set' },
      { id: '10x2-5x4',  label: '2 × 10 kg + 4 × 5 kg',      note: 'Smallest steps up' }
    ],
    60: [
      { id: '20x2-10x2', label: '2 × 20 kg + 2 × 10 kg',     note: 'Fewest plates to store' },
      { id: '10x6',      label: '6 × 10 kg',                 note: 'A good all-round set' },
      { id: '10x4-5x4',  label: '4 × 10 kg + 4 × 5 kg',      note: 'Smallest steps up' }
    ],
    80: [
      { id: '20x4',      label: '4 × 20 kg',                 note: 'Fewest plates to store' },
      { id: '20x2-10x4', label: '2 × 20 kg + 4 × 10 kg',     note: 'A good all-round set' },
      { id: '20x2-10x2-5x4', label: '2 × 20 + 2 × 10 + 4 × 5 kg', note: 'Smallest steps up' }
    ]
  };

  function plateMixes() { return PLATE_MIXES[B.plateKg] || null; }

  /* ======================================================================
     STEP 1 — HOW MUCH WEIGHT

     The first of two plate questions, and the one that changes the price.
     It used to be a chooser that floated over the homepage before this page
     was ever reached, which meant the answer was given against four posters
     and a number rather than against the package it buys. Asked here, the
     thing being bought is on screen underneath it the whole time.

     Answering it rewrites the page in place — name, price, poster, contents
     and the split options below — rather than loading the tier's own URL.
     A page load here would throw away the extras somebody had already added
     and put them back at the top of a page they had just read.
     ====================================================================== */

  var tierBox = null;

  function tierChoice() {
    if (!FAM) return;                       /* a package with no siblings */

    var box = document.createElement('section');
    box.className = 'bmix btier ' + (tierChosen ? 'is-done' : 'is-required');
    box.innerHTML =
      '<h2><span class="bmix__req">Step 1</span>How many kilos of plates?</h2>' +
      '<p class="bmix__sub">Same machine, same bench, same 7 ft bar. The weight in the box is the ' +
      'only difference, and it is the only thing that changes the price. <b>Pick one to carry on.</b></p>' +
      '<div class="bmix__row" role="radiogroup" aria-label="Choose how many kilos of plates"></div>';

    var row = box.querySelector('.bmix__row');
    FAM.tiers.forEach(function (t) {
      var on = tierChosen && t.id === B.id;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bmix__opt' + (on ? ' is-on' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.innerHTML = '<b>' + t.plateKg + ' kg</b><small>' + money(t.price) +
        (t.was && t.was > t.price ? ' &middot; save ' + money(t.was - t.price) : '') + '</small>';
      b.addEventListener('click', function () { setTier(t, row, b); });
      row.appendChild(b);
    });

    var inside = qs('bitems').parentNode;
    inside.parentNode.insertBefore(box, inside.nextSibling);
    tierBox = box;
  }

  /* Everything on the page that names a weight, a price or a contents list
     is rebuilt. The extras are deliberately NOT cleared — somebody who
     added flooring and then changed the plate weight has not changed their
     mind about the flooring — but they lock again, because the split below
     is unanswered once more. */
  function setTier(t, row, btn) {
    B = t;
    tierChosen = true;
    state.mix = null;

    [].forEach.call(row.children, function (c) {
      c.classList.remove('is-on');
      c.setAttribute('aria-checked', 'false');
    });
    btn.classList.add('is-on');
    btn.setAttribute('aria-checked', 'true');
    tierBox.classList.remove('is-required');
    tierBox.classList.add('is-done');

    head();
    rebuildItems();
    rebuildMix();
    hideExtras();
    qs('barName').textContent = B.name;
    refresh();

    /* The address bar catches up, so a refresh or a shared link lands on
       the package they actually chose rather than back on the question. */
    try {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + '?b=' + B.id);
      }
    } catch (e) {}
  }

  function rebuildItems() {
    var box = qs('bitems');
    box.innerHTML = '';
    box.classList.remove('bitems--single');
    qs('bperks').innerHTML = '';
    items();
  }

  function rebuildMix() {
    var old = document.querySelector('.bmix--split');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    plateChoice();
  }

  /* ======================================================================
     STEP 2 — HOW THEY ARE SPLIT

     Locked until step 1 is answered, and visibly so: until a weight exists
     there is nothing to split, and the options for 20 kg are not the
     options for 80. Shown rather than hidden, so the second question is
     something you can see coming rather than something that appears from
     nowhere once the first is done.
     ====================================================================== */

  function plateChoice() {
    var pending = tierNeeded();
    var mixes = pending ? null : plateMixes();
    if (!pending && !mixes) return;         /* a package with no plates in it */

    var box = document.createElement('section');
    box.className = 'bmix bmix--split ' + (pending ? 'bmix--locked' : 'is-required');
    box.innerHTML = pending
      ? '<h2><span class="bmix__req">Step 2</span>How would you like them split?</h2>' +
        '<p class="bmix__sub">Choose how many kilos above first &mdash; then this asks which ' +
        'plates to load on the truck.</p>' +
        '<div class="bmix__row"></div>'
      : '<h2><span class="bmix__req">Step 2</span>How would you like the ' + B.plateKg + ' kg?</h2>' +
        '<p class="bmix__sub">Same weight, same price — just tell us which plates to load on the truck. ' +
        '<b>Pick one to carry on.</b></p>' +
        '<div class="bmix__row" role="radiogroup" aria-label="Choose your plates"></div>';

    var row = box.querySelector('.bmix__row');
    if (pending) {
      var anchorP = tierBox || qs('bitems').parentNode;
      anchorP.parentNode.insertBefore(box, anchorP.nextSibling);
      hideExtras();
      return;
    }
    mixes.forEach(function (mix, i) {
      var b = document.createElement('button');
      b.type = 'button';
      /* Nothing is pre-picked. It used to default to the first option, which
         meant the question could be scrolled past without being read and the
         plates were chosen for you — this is a real choice about what turns
         up on the truck, so it has to be made rather than inherited. */
      b.className = 'bmix__opt';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.innerHTML = '<b>' + mix.label + '</b><small>' + mix.note + '</small>';
      b.addEventListener('click', function () {
        state.mix = mix;
        [].forEach.call(row.children, function (c) {
          c.classList.remove('is-on');
          c.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-on');
        b.setAttribute('aria-checked', 'true');
        box.classList.remove('is-required');
        box.classList.add('is-done');
        revealExtras();
        refresh();
      });
      row.appendChild(b);
    });

    /* Under step 1 when there is one, otherwise straight under the contents. */
    var anchor = tierBox || qs('bitems').parentNode;
    anchor.parentNode.insertBefore(box, anchor.nextSibling);

    /* The extras only exist once the required question is answered — see
       revealExtras(). Nothing to reveal on a package with no plates in it. */
    hideExtras();
  }

  /* ------------------------------------------------------------------
     THE EXTRAS COME SECOND

     Asking "how many MORE plates?" while the visitor has not yet said how
     they want the plates they are already paying for is two plate questions
     at once, and the optional one was landing first. It stays out of the
     way until the required choice is made, so the page asks one thing at a
     time and the order they come in matches the order they matter.
     ------------------------------------------------------------------ */
  function exBox() { return document.querySelector('.bex'); }

  function hideExtras() {
    var ex = exBox();
    if (ex) ex.classList.add('bex--locked');
  }

  function revealExtras() {
    var ex = exBox();
    if (!ex || !ex.classList.contains('bex--locked')) return;
    ex.classList.remove('bex--locked');
  }

  /* Nothing can be ordered until the plate split is answered. The button is
     left visible and disabled rather than hidden, so it is obvious that
     there is a step still to do rather than that the page is broken. */
  function mixNeeded() { return tierNeeded() || (!!plateMixes() && !state.mix); }

  function syncGate() {
    var need = mixNeeded();
    var add = qs('addCart');
    var bar = document.querySelector('.bbar__cta');
    [add, bar].forEach(function (el) {
      if (!el) return;
      el.disabled = need;
      el.classList.toggle('is-locked', need);
      if (need) el.setAttribute('title', tierNeeded()
        ? 'Choose how many kilos of plates first'
        : 'Choose how you want your plates first');
      else el.removeAttribute('title');
    });
  }

  /* the cart and the WhatsApp message quote the plates the way they were chosen */
  function includesLines() {
    return B.includes.map(function (line) {
      if (state.mix && /kg of rubber olympic plates/i.test(line)) {
        return line + ' — ' + state.mix.label;
      }
      return line;
    });
  }

  /* ======================================================================
     EXTRAS — the picker the package card used to hide
     ====================================================================== */

  function extras() {
    window.IFZPlates(qs('plates'), function (kgNow) {
      state.plates = kgNow;
      refresh();
    });

    /* Flooring, at the same $39 the accessories page charges. Unlike plates
       it has no package rate to undercut: the package never contains any, so
       there is nothing to avoid charging twice for. */
    var fh = qs('floor');
    if (fh) {
      window.IFZFloor(fh, function (m2Now) {
        state.floor = m2Now;
        refresh();
      }, FLOOR_PER_M2);
    }
  }

  /* ======================================================================
     THE TOTAL — one number, written everywhere at once
     ====================================================================== */

  function extraList() {
    var out = [];
    if (state.floor > 0) {
      out.push({ key: 'floor', m2: state.floor,
                 name: 'Rubber flooring — ' + state.floor + ' m² (' + (state.floor * 4) + ' tiles)',
                 price: state.floor * FLOOR_PER_M2 });
    }
    if (state.plates > 0) {
      /* the package plate rate, which Shopify sells as UPG-PLATES-* */
      out.push({ key: 'upg-plates', kg: state.plates,
                 name: 'Extra plates — ' + state.plates + ' kg',
                 price: state.plates * PKG_PLATE_RATE });
    }
    return out;
  }

  function total() {
    var base = tierNeeded() ? famLow() : B.price;
    return extraList().reduce(function (s, e) { return s + e.price; }, base);
  }

  var added = false;

  function refresh() {
    var t = total();
    var ex = extraList();

    var from = tierNeeded() ? 'from ' : '';
    qs('totalN').textContent = from + money(t);
    qs('barTotal').textContent = from + money(t);

    /* the phone bar shows the crossed-out price only while nothing is added,
       so it never claims a saving against a total that has extras in it */
    var wasEl = qs('barWas');
    wasEl.textContent = B.was ? money(B.was) : '';
    wasEl.hidden = !B.was || ex.length > 0;

    var lines = qs('totalLines');
    lines.innerHTML = '';
    if (ex.length) {
      [{ name: B.name, price: B.price }].concat(ex).forEach(function (e) {
        var li = document.createElement('li');
        var n = document.createElement('span');
        n.textContent = e.name;
        var p = document.createElement('b');
        p.textContent = money(e.price);
        li.appendChild(n);
        li.appendChild(p);
        lines.appendChild(li);
      });
    }

    if (!added) {
      qs('addCart').textContent = '🛒 Add to cart' + (ex.length ? ' — ' + money(t) : '');
    syncGate();
    }

  }

  /* ======================================================================
     ADD TO CART — same item shape the carousel has always written
     ====================================================================== */

  function addToCart() {
    /* The button is disabled while this is true, but a disabled button is a
       presentation detail — the thing that must not happen is a package
       reaching the cart without the plate split that was asked for. */
    if (mixNeeded()) {
      /* Point at whichever step is actually unanswered. Scrolling somebody
         to the split when the weight is what is missing is being told off
         for the wrong thing. */
      var box = tierNeeded()
        ? tierBox
        : document.querySelector('.bmix--split');
      if (box) {
        box.classList.add('is-required');
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }

    if (added) { window.location.href = window.IFZU('cart-revamp.html'); return true; }

    window.IFZCart.add({
      type: 'package',
      name: B.name,
      price: B.price,
      img: B.img2x || B.img,
      key: B.cod || ('pkg-' + B.id),
      extras: extraList(),
      includes: includesLines()
    });

    added = true;

    var cart = qs('addCart');
    cart.classList.add('is-added');
    cart.textContent = '✓ Added! View cart →';

    var bar = qs('barCta');
    bar.classList.add('is-added');
    bar.textContent = 'Added! View cart →';
  }

  /* ======================================================================
     THE OTHER PACKAGES
     ====================================================================== */

  function others() {
    var row = qs('moreRow');
    var T = window.IFZTiers;

    /* COLLAPSED, like everywhere else.

       This listed every other package one by one — seven cards, and five of
       them the same two posters with a different number printed on them. It
       is the exact pile the plate choosers were built to replace, quietly
       rebuilt at the bottom of every package page.

       Now: ordinary packages as themselves, and one card per family — and
       never this package's own family, which is the picker at the top of
       this page. */
    function card(href, img, title, sub, onClick) {
      var a = document.createElement('a');
      a.className = 'more__card';
      a.href = href;
      a.innerHTML =
        '<div class="more__thumb">' + picture(img, '') + '</div>' +
        '<div><b></b><span></span></div>';
      a.querySelector('b').textContent = title;
      a.querySelector('span').textContent = sub;
      if (onClick) a.addEventListener('click', onClick);
      row.appendChild(a);
    }

    var mine = T && T.groupFor(B.id);
    var done = {};

    LIST.forEach(function (o) {
      var g = T && T.groupFor(o.id);

      if (!g) {
        if (o.id === B.id) return;
        card(o.href, o.img, o.name, money(o.price) + ' + delivery');
        return;
      }

      if (done[g.key]) return;
      done[g.key] = 1;

      /* This package's OWN family is not listed here. The other plate
         weights are the picker at the top of this page — offering them
         again at the bottom, as "4 options from $899", reads as a different
         product and sends somebody back out of a page they are already on. */
      if (mine && mine.key === g.key) return;

      var others = g.tiers;
      if (!others.length) return;
      var lo = Math.min.apply(null, others.map(function (t) { return t.price; }));

      card(
        'bundle.html?fam=' + g.key,
        g.tiers[0].img,
        g.name,
        others.length + ' plate weights — from ' + money(lo)
      );
    });
  }

  /* ======================================================================
     GO
     ====================================================================== */

  head();
  threeD();
  items();
  tierChoice();      /* step 1 — must exist before step 2 looks for it */
  plateChoice();     /* step 2 */
  extras();
  others();

  qs('barName').textContent = B.name;
  qs('addCart').addEventListener('click', addToCart);

  /* ------------------------------------------------------------------
     ORDERING, CASH ON DELIVERY

     Through the cart rather than EasySell's own button, for the same reason
     as the machine pages: this page carries a plate split and extra plates.
     EasySell's product button knows about none of them —
     and this is not even a product page, so it has no product to work from.
     The cart is the one place that holds the whole order, and EasySell's
     COD button is waiting there.
     ------------------------------------------------------------------ */
  qs('barCta').addEventListener('click', addToCart);

  /* Once the real order block is on screen the pinned bar is just a second
     copy of it, so it steps aside — same behaviour as the machine page. */
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      qs('bbar').classList.toggle('is-away', entries[0].isIntersecting);
    }, { rootMargin: '-40px 0px -120px 0px' }).observe(qs('orderBox'));
  }

  refresh();
})();
